const toWords = (value) =>
	value?.toString().toLowerCase().match(/[a-z0-9]+/g) || [];

// True when the model name starts with the make, e.g. make "Mazda" and model
// "Mazda3" — rendering both would produce "Mazda Mazda3". Case and separators
// are ignored ("Mercedes-Benz" matches "Mercedes Benz Sprinter"), but the make
// must not run into more letters, so "Mini" does not match "Minivan".
const isMakeInModel = (vehicle) => {
	const makeWords = toWords(vehicle?.make);
	const model = vehicle?.model?.toString().toLowerCase();
	if (!makeWords.length || !model) {
		return false;
	}
	const makePrefix = new RegExp(
		`^[^a-z0-9]*${makeWords.join('[^a-z0-9]*')}(?![a-z])`
	);
	return makePrefix.test(model);
};

export const getModelTitle = (
	modelTitleAttributes = ['model'],
	vehicle,
	{ skipMakeIfInModel = false } = {}
) => {
	const validAttributes = ['year', 'make', 'model', 'gvBodyStyle', 'trim'];
	const vehicleTitleAttributes = modelTitleAttributes.split(',');
	const skipMake =
		skipMakeIfInModel &&
		vehicleTitleAttributes.map((a) => a.trim()).includes('model') &&
		isMakeInModel(vehicle);
	const titleValues = [];
	vehicleTitleAttributes.forEach((attribute) => {
		const cleanedAttribute = attribute.trim();
		if (skipMake && cleanedAttribute === 'make') {
			return;
		}
		if (
			validAttributes.includes(cleanedAttribute) &&
			vehicle[cleanedAttribute]
		) {
			titleValues.push(`${vehicle[cleanedAttribute]?.toString()}`);
		}
	});
	return titleValues.join(' ');
};
